import { render, staticRenderFns } from "./daiw.vue?vue&type=template&id=2ba8dbd6&scoped=true"
import script from "./daiw.vue?vue&type=script&lang=js"
export * from "./daiw.vue?vue&type=script&lang=js"
import style0 from "./daiw.vue?vue&type=style&index=0&id=2ba8dbd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8dbd6",
  null
  
)

export default component.exports